import { reviewBodySchema } from "@redotech/redo-model/review/review-body-schema";
import * as z from "zod/v4";

export const getReviewById = {
  name: "getReviewById" as const,
  input: z.object({ reviewId: z.string() }),
  output: z.object({ review: reviewBodySchema }),
};
